module.exports = __webpack_public_path__ + "img/landing-image.51d5630.png";